// Fade efect
import { fade } from '@material-ui/core/styles/colorManipulator';
// import red from '@material-ui/core/colors/red';
import {
  // container,
  // defaultFont,
  // primaryColor,
  // defaultBoxShadow,
  // infoColor,
  // successColor,
  // warningColor,
  // dangerColor,
  // whiteColor,
  grayColor
} from "assets/jss/material-kit-pro-react.jsx";

export default theme => ({
  root: {
    // borderBottom: `1px solid ${theme.palette.border}`,
    //backgroundColor: "#d12121",
    backgroundColor: "transparent",
    color: grayColor[7],
    display: 'flex',
    alignItems: 'center',
    height: '64px',
    zIndex: theme.zIndex.appBar
  },
  toolbar: {
    minHeight: 'auto',
    width: '100%'
  },
  title: {
    color: grayColor[7],
    marginLeft: theme.spacing.unit
  },
  menuButton: {
    color: grayColor[7],
    marginLeft: '-4px'
  },
  notificationsButton: {
    color: grayColor[7],
    marginLeft: 'auto'
  },
  signOutButton: {
    color: grayColor[7],
    marginLeft: theme.spacing.unit
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(grayColor[7], 0.25),
    '&:hover': {
      backgroundColor: fade(grayColor[7], 0.35),
    },
    marginRight: theme.spacing.unit * 2,
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing.unit * 3,
      width: 'auto',
    },
  },

  searchIcon: {
    color: theme.palette.common.white,
    width: theme.spacing.unit * 9,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  inputRoot: {
    color: 'inherit',
    width: '100%',
  },

  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  }
});
